const initTabList = () => {
    const tabListWidgetList = document.querySelectorAll("[data-tab-list-widget]");
    if (tabListWidgetList && tabListWidgetList.length > 0) {
        tabListWidgetList.forEach((tabListWidget) => {
            const tabList = tabListWidget.querySelectorAll("[data-tab]");
            const tabContainerList = tabListWidget.querySelectorAll("[data-tab-container]");
            if (tabList && tabContainerList && tabList.length > 0 && tabContainerList.length > 0) {
                tabList.forEach((tab) => {
                    tab.addEventListener("click", () => {
                        reset(tabList);
                        reset(tabContainerList);
                        tabContainerList.forEach((tabContainer) => {
                            if (parseInt(tab.getAttribute("data-tab")) === parseInt(tabContainer.getAttribute("data-tab-container"))) {
                                tab.classList.add("active");
                                tabContainer.classList.add("active");
                            }
                        });
                    });
                });
            }
        });
    }
};
const reset = (elementList) => {
    elementList.forEach((element) => {
        element.classList.remove("active");
    });
};
